import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ShieldCheck, ShieldX } from "lucide-react";
import { api, peso, errMsg } from "../lib/api";

export default function VerifyReport() {
  const { ref } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/public/verify/${ref}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); }, [ref]);
  const T = d?.totals || {};
  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center p-4">
      <div className="max-w-lg w-full rounded-2xl border border-[#E4DACD] bg-white p-6 sm:p-8 fade-up">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#C85A32]">Saint Francis of Assisi Parish · GKK-FMIS</p>
        <h1 className="font-serif text-2xl font-bold mt-2">Report Authenticity Check</h1>
        {err && <div data-testid="verify-not-found" className="mt-6 flex gap-3 rounded-xl bg-[#FEF2F2] p-4 text-[#B91C1C]"><ShieldX className="h-6 w-6 shrink-0" /> {err}</div>}
        {d && (
          <div data-testid="verify-result" className="mt-6 space-y-3">
            <div className="flex gap-3 rounded-xl bg-[#E8F5E9] p-4 text-[#1B5E3F] font-semibold"><ShieldCheck className="h-6 w-6 shrink-0" /> This report {d.ref} was generated by the official system.</div>
            {[["GKK", d.scope_name], ["Unit", d.unit_name], ["Period", d.period], ["Status at generation", d.status], ["Generated (PST)", d.generated_at?.replace("T", " ")],
              ["Gross collections", peso(T.gross_collections_cents)], ["Expenses paid", peso(T.expenses_paid_cents)], ["Remittances", peso(T.remittances_cents)],
              ["Total cash & bank balance", peso(T.total_balance_cents)]].map(([a, b]) => (
              <div key={a} className="flex justify-between gap-4 border-b border-[#F3EDE2] pb-2 text-sm"><span className="text-[#6E6259]">{a}</span><span className="font-semibold text-right">{b}</span></div>
            ))}
            <p className="text-xs text-[#6E6259]">Compare these totals with the printed report. Any later authorized corrections are recorded in the system's audit history.</p>
          </div>
        )}
        <Link to="/public" className="inline-block mt-6 font-semibold text-[#C85A32]">Public transparency summary →</Link>
      </div>
    </div>
  );
}
